module.exports = __webpack_public_path__ + "fonts/Graphik-MediumItalic-Web.9e5d5ca.woff";